<template>
  <article class="related-post-item" @click="navigate">
    <div class="related-post-item__picture">
      <LazyPicture
        v-if="post.thumbnail"
        :picture="post.thumbnail"
        :title="post.title"
        class="h-full w-full"
        :is-free="post.isFree"
      />
    </div>
    <PostTitle
      :title="post.title"
      :permalink="url"
      class="related-post-item__title"
    />
  </article>
</template>

<script>
import PostTitle from '../PostTitle.vue'
import { undomainify } from '~plugins/utils'
import LazyPicture from '~components/utils/LazyPicture.vue'

export default {
  components: {
    PostTitle,
    LazyPicture,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return undomainify(this.post.link)
    },
  },
  methods: {
    navigate() {
      this.$router.push(this.url)
    },
  },
}
</script>

<style>
@import '~components/content/widgets/RelatedPost.css';
</style>
